import Vue from "vue";
import Router from "vue-router";

// routes
import Login from "@/views/pages/account/routes.account/";
import Studio from "@/views/pages/studio/routes.studio/";
import Dashboard from "@/views/pages/dashboard/routes.dashboard/";
import Settings from "@/views/pages/settings/routes.settings/";
Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,

  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [
    ...Login,
    {
      path: "/dashboard",
      component: () => import("@/views/layouts/main/"),
      children: [
        ...Dashboard,
        ...Settings,
        ...Studio,
      ],
      
    },

    // Redirect to 404 page, if no match found
    {
      path: "/not-found",
      component: () => import(/* webpackChunkName: "404" */ "@/views/Error404"),
    },
    { path: "*", redirect: "/not-found" },
  ],
});

router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
